export const WAREHOUSE_AREAS_LIST_KEY = 'WAREHOUSE_AREAS_LIST_KEY';
export const WAREHOUSE_AREAS_ONE_KEY = 'WAREHOUSE_AREAS_ONE_KEY';
